import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { request } from '../utils';
import UserHeader from '../UserHeader';
import upArrow from '../Dashboard/img/upArrow.png';
import '../Dashboard/matchup.css';
import '../Player/player.css';
import '../UserHeader/style.css';
import '../Dashboard/style.css';
import '../Loading/style.css';
import PlayerTwitterFeed from '../Player/News/TwitterFeed';
// import '../global/css/globalStyle.css';

const normalizeTeamTwitterInfo = (raw) => {
	try {
		if (raw == null) return [];
		let value = raw;
		if (typeof value === 'string') {
			value = JSON.parse(value);
		}
		if (Array.isArray(value)) return value;
		if (value && Array.isArray(value.tweets)) return value.tweets;
		return [];
	} catch (e) {
		return [];
	}
};

const safeParseJson = (raw) => {
	try {
		if (!raw || typeof raw !== 'string') return raw || {};
		return JSON.parse(raw);
	} catch (e) {
		return {};
	}
};

const normalizeTwitterTweet = (tweet) => {
	const profileData = safeParseJson(tweet?.profile_data || tweet?.data);
	const tweetData = safeParseJson(tweet?.tweet_data);

	return {
		...tweet,
		twitter_username: tweet?.twitter_username || profileData?.username || '',
		profile_image_url: tweet?.profile_image_url || profileData?.profile_image_url || '',
		tweet_text: tweet?.tweet_text || tweetData?.text || '',
		tweet_date: tweet?.tweet_date || tweetData?.created_at || '',
		media_url: tweet?.media_url || ''
	};
};

const getCurrentCricketSeason = () => `${new Date().getFullYear()}`;

const extractScheduleDateValue = (value) => {
	if (!value) return '';
	if (typeof value === 'object' && value.date) {
		return value.date;
	}
	return value;
};

const buildScheduleTeamName = (...parts) =>
	parts
		.map((part) => `${part || ''}`.trim())
		.filter((part) => part && part.toLowerCase() !== 'null')
		.filter((part, index, array) => array.indexOf(part) === index)
		.join(' ');

const normalizeSchedule = (schedule) => {
	if (!schedule || typeof schedule !== 'object') return null;

	const isLegacyShape = schedule.home_team_id != null || schedule.away_team_id != null;
	if (isLegacyShape) {
		const homeTeamName =
			buildScheduleTeamName(schedule.home_team_city, schedule.home_team_name) ||
			schedule.home_team_name ||
			schedule.home_team ||
			'';
		const awayTeamName =
			buildScheduleTeamName(schedule.away_team_city, schedule.away_team_name) ||
			schedule.away_team_name ||
			schedule.away_team ||
			'';

		return {
			...schedule,
			match_id: schedule.match_id || schedule.game_id || schedule.id || null,
			team_a_id: schedule.home_team_id,
			team_b_id: schedule.away_team_id,
			team_a_name: homeTeamName,
			team_b_name: awayTeamName,
			team_a_short_name: schedule.home_team || schedule.home_team_short_name || schedule.home_team_name || homeTeamName,
			team_b_short_name: schedule.away_team || schedule.away_team_short_name || schedule.away_team_name || awayTeamName,
			team_a_logo_url: schedule.home_team_logo || schedule.home_team_logo_url || '',
			team_b_logo_url: schedule.away_team_logo || schedule.away_team_logo_url || '',
			format_str: schedule.format_str || schedule.league || schedule.competition || 'IPL',
			match_number: schedule.match_number || schedule.subtitle || schedule.match_label || '',
			date_start_ist: extractScheduleDateValue(schedule.date_start_ist || schedule.date_time || schedule.match_date || ''),
			status_str: schedule.status_str || schedule.status || 'Scheduled',
			title: schedule.title || schedule.short_title || '',
			short_title: schedule.short_title || ''
		};
	}

	return {
		...schedule,
		match_id: schedule.match_id || schedule.game_id || schedule.id || null,
		team_a_id: schedule.team_a_id,
		team_b_id: schedule.team_b_id,
		team_a_name: schedule.team_a_name || '',
		team_b_name: schedule.team_b_name || '',
		team_a_short_name: schedule.team_a_short_name || schedule.team_a_name || '',
		team_b_short_name: schedule.team_b_short_name || schedule.team_b_name || '',
		team_a_logo_url: schedule.team_a_logo_url || '',
		team_b_logo_url: schedule.team_b_logo_url || '',
		format_str: schedule.format_str || schedule.league || schedule.competition || 'IPL',
		match_number: schedule.match_number || schedule.subtitle || '',
		date_start_ist: extractScheduleDateValue(schedule.date_start_ist || schedule.date_time || ''),
		status_str: schedule.status_str || schedule.status || 'Scheduled',
		title: schedule.title || '',
		short_title: schedule.short_title || ''
	};
};

const normalizeSchedules = (raw) => {
	if (!Array.isArray(raw)) return [];

	return raw
		.map(normalizeSchedule)
		.filter(Boolean)
		.sort((a, b) => {
			const firstDate = new Date(a?.date_start_ist || 0).getTime();
			const secondDate = new Date(b?.date_start_ist || 0).getTime();

			if (Number.isNaN(firstDate) && Number.isNaN(secondDate)) return 0;
			if (Number.isNaN(firstDate)) return 1;
			if (Number.isNaN(secondDate)) return -1;
			return firstDate - secondDate;
		});
};


function CricketTeamDetails(props) {
	const { user } = props;
	const { id: teamID } = useParams();
	const newsSentinelRef = useRef(null);
	const [state, setState] = useState({ 
		loading: true, 
		teamInfo: null, 
		players: [], 
		teamTwitterInfo: [],
		news: [],
		newsPagination: { limit: 3, offset: 0, hasMore: false, nextOffset: 0 },
		newsLoading: false,
		schedules: [],
		schedulesLoading: true,
		error: null,
		showLegend: false,
		expandedCategories: {}
	});
 
	useEffect(() => {
		const fetchTeamDetails = async () => {
			try {
				const res = await request({}, `/api/cricket/team/${teamID}`, 'GET', user?.token);
				const apiData = res?.data?.data || {};
				const teamInfo = Array.isArray(apiData.teamInfo) && apiData.teamInfo.length > 0 ? apiData.teamInfo[0] : null;
				const players = Array.isArray(apiData.playerInfo) ? apiData.playerInfo : [];
				const teamTwitterInfo = normalizeTeamTwitterInfo(apiData.teamTwitterInfo).map(normalizeTwitterTweet);
				const schedules = normalizeSchedules(apiData.schedules);

				setState((prev) => ({
					...prev,
					loading: false,
					teamInfo,
					players,
					teamTwitterInfo,
					schedules,
					error: null
				}));
			} catch (e) {
				setState((prev) => ({
					...prev,
					loading: false,
					teamInfo: null,
					players: [],
					teamTwitterInfo: [],
					news: [],
					newsPagination: { limit: 3, offset: 0, hasMore: false, nextOffset: 0 },
					newsLoading: false,
					schedules: [],
					schedulesLoading: false,
					error: 'Unable to load team data'
				}));
			}
		};
		fetchTeamDetails();
	}, [teamID, user?.token]);

	useEffect(() => {
		const fetchSchedules = async () => {
			setState((prev) => ({ ...prev, schedulesLoading: true }));
			try {
				const activeLeague = state.teamInfo?.league || user?.league || 'IPL';
				const currentSeason = getCurrentCricketSeason();
				const publicParams = new URLSearchParams({
					league: activeLeague,
					season: currentSeason,
					limit: '250'
				});
				const publicRes = await request({}, `/api/cricket/schedules?${publicParams.toString()}`, 'GET', user?.token);
				const publicData = publicRes?.data?.data || {};
				const publicSchedules = normalizeSchedules(publicData?.schedules);
				const activeTeamId = `${state.teamInfo?.team_id || teamID}`;
				let schedules = publicSchedules.filter(
					(schedule) =>
						`${schedule?.team_a_id || ''}` === activeTeamId || `${schedule?.team_b_id || ''}` === activeTeamId
				);

				if (schedules.length === 0) {
					const res = await request({}, `/main/4/teamschedule/${teamID}`, 'GET', user?.token);
					const apiData = res?.data?.data;
					const rawSchedules = Array.isArray(apiData?.teamInfo) ? apiData.teamInfo : Array.isArray(apiData) ? apiData : [];
					schedules = normalizeSchedules(rawSchedules);
				}

				setState((prev) => ({
					...prev,
					schedules: schedules.length > 0 ? schedules : prev.schedules,
					schedulesLoading: false
				}));
			} catch (e) {
				setState((prev) => ({
					...prev,
					schedulesLoading: false
				}));
			}
		};

		fetchSchedules();
	}, [teamID, user?.league, user?.token, state.teamInfo?.team_id, state.teamInfo?.league]);

	useEffect(() => {
		const fetchInitialNews = async () => {
			try {
				setState((prev) => ({ ...prev, newsLoading: true }));
				const res = await request({}, `/api/cricket/team/${teamID}/news?limit=3&offset=0`, 'GET', user?.token);
				const apiData = res?.data?.data || {};
				const news = Array.isArray(apiData.news) ? apiData.news : [];
				const pagination = apiData.pagination && typeof apiData.pagination === 'object' ? apiData.pagination : { limit: 3, offset: 0, hasMore: false, nextOffset: news.length };
				setState((prev) => ({
					...prev,
					news,
					newsPagination: pagination,
					newsLoading: false
				}));
			} catch (e) {
				setState((prev) => ({
					...prev,
					news: [],
					newsPagination: { limit: 3, offset: 0, hasMore: false, nextOffset: 0 },
					newsLoading: false
				}));
			}
		};
		fetchInitialNews();
	}, [teamID, user?.token]);

	useEffect(() => {
		const sentinel = newsSentinelRef.current;
		if (!sentinel) return;

		const observer = new IntersectionObserver(
			(entries) => {
				const [entry] = entries;
				if (!entry?.isIntersecting) return;
				setState((prev) => {
					if (prev.newsLoading || !prev.newsPagination?.hasMore) return prev;
					return { ...prev, newsLoading: true };
				});
			},
			{ root: null, rootMargin: '250px', threshold: 0 }
		);

		observer.observe(sentinel);
		return () => observer.disconnect();
	}, [state.news.length]);

	useEffect(() => {
		const onScroll = () => {
			const sentinel = newsSentinelRef.current;
			if (!sentinel) return;
			const rect = sentinel.getBoundingClientRect();
			const nearViewport = rect.top <= window.innerHeight + 250;
			if (!nearViewport) return;
			setState((prev) => {
				if (prev.newsLoading || !prev.newsPagination?.hasMore) return prev;
				return { ...prev, newsLoading: true };
			});
		};
		window.addEventListener('scroll', onScroll);
		return () => window.removeEventListener('scroll', onScroll);
	}, []);

	useEffect(() => {
		const loadMore = async () => {
			if (!state.newsLoading) return;
			const { newsPagination } = state;
			if (!newsPagination?.hasMore) {
				setState((prev) => ({ ...prev, newsLoading: false }));
				return;
			}
			try {
				const nextOffset = Number.isFinite(Number(newsPagination.nextOffset)) ? Number(newsPagination.nextOffset) : 0;
				const limit = Number.isFinite(Number(newsPagination.limit)) ? Number(newsPagination.limit) : 3;
				const res = await request({}, `/api/cricket/team/${teamID}/news?limit=${limit}&offset=${nextOffset}`, 'GET', user?.token);
				const apiData = res?.data?.data || {};
				const nextNews = Array.isArray(apiData.news) ? apiData.news : [];
				const nextPagination = apiData.pagination && typeof apiData.pagination === 'object' ? apiData.pagination : { limit, offset: nextOffset, hasMore: false, nextOffset: nextOffset + nextNews.length };
				setState((prev) => ({
					...prev,
					news: Array.isArray(prev.news) ? [...prev.news, ...nextNews] : nextNews,
					newsPagination: nextPagination,
					newsLoading: false
				}));
			} catch (e) {
				setState((prev) => ({ ...prev, newsLoading: false, newsPagination: { ...(prev.newsPagination || {}), hasMore: false } }));
			}
		};
		loadMore();
	}, [state.newsLoading, state.newsPagination, teamID, user?.token]);

	const toggleLegend = () => {
		setState((prev) => ({ ...prev, showLegend: !prev.showLegend }));
	};

	const toggleCategory = (categoryKey) => {
		setState((prev) => ({ 
			...prev, 
			expandedCategories: {
				...prev.expandedCategories,
				[categoryKey]: !prev.expandedCategories[categoryKey]
			}
		}));
	};

	const renderTeamLogo = (teamName, logoUrl) => {
		if (logoUrl && logoUrl !== '') {
			return <img src={logoUrl} alt={teamName} style={{ width: '20px', height: '20px', borderRadius: '50%' }} />;
		}
		// Fallback SVG with team color based on team name
		const getTeamColor = (name) => {
			const colorMap = {
				'PBKS': '#e31c3d', 'CSK': '#f9cd05', 'GT': '#333', 'KKR': '#3a225d', 'SRH': '#f26522',
				'MI': '#005da1', 'RCB': '#d32f2f', 'DC': '#004c9f', 'RR': '#254aa5'
			};
			return colorMap[name] || '#666';
		};
		
		return (
			<svg width="20" height="20" viewBox="0 0 24 24">
				<circle cx="12" cy="12" r="10" fill={getTeamColor(teamName)} />
			</svg>
		);
	};

	const formatDate = (dateString) => {
		const normalizedDate = extractScheduleDateValue(dateString);
		if (!normalizedDate) return '';
		const date = new Date(normalizedDate);
		if (Number.isNaN(date.getTime())) return '';
		return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
	};

	const formatTime = (dateString) => {
		const normalizedDate = extractScheduleDateValue(dateString);
		if (!normalizedDate) return '';
		const date = new Date(normalizedDate);
		if (Number.isNaN(date.getTime())) return '';
		return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
	};

	const calculateAge = (dateOfBirth) => {
		if (!dateOfBirth) return 'N/A';
		try {
			const birthDate = new Date(dateOfBirth);
			const currentDate = new Date();
			let age = currentDate.getFullYear() - birthDate.getFullYear();
			const monthDifference = currentDate.getMonth() - birthDate.getMonth();
			if (monthDifference < 0 || (monthDifference === 0 && currentDate.getDate() < birthDate.getDate())) {
				age--;
			}
			return age.toString();
		} catch (error) {
			return 'N/A';
		}
	};

	const convertInchesToFeet = (inches) => {
		if (!inches) return 'N/A';
		try {
			const totalInches = parseFloat(inches);
			const feet = Math.floor(totalInches / 12);
			const remainingInches = Math.round(totalInches % 12);
			
			if (feet === 0) return `${remainingInches} in`;
			if (remainingInches === 0) return `${feet} ft`;
			return `${feet} ft ${remainingInches} in`;
		} catch (error) {
			return 'N/A';
		}
	};

	if (state.loading) {
		return (
			<div id='fullHeight'>
				<div id='loading' />
			</div>
		);
	}

	if (state.error || !state.teamInfo) {
		return (
			<div className='gameMainDiv'>
				<UserHeader backgroundColor={'#f7f7f7'} title='Team Details' />
				<div className='container' style={{ padding: '50px', textAlign: 'center' }}>
					<h2>Team Not Found</h2>
					<p>Unable to load team information. Please try again later.</p>
				</div>
			</div>
		);
	}

	const { teamInfo, players, news, teamTwitterInfo } = state;
	const primaryTwitterInfo = Array.isArray(teamTwitterInfo) && teamTwitterInfo.length > 0 ? teamTwitterInfo[0] : null;
	const parsedTwitterProfile = safeParseJson(primaryTwitterInfo?.profile_data || primaryTwitterInfo?.data);
	const twitterHandle = primaryTwitterInfo?.twitter_username || parsedTwitterProfile?.username || '';
	const twitterProfileImage = primaryTwitterInfo?.profile_image_url || parsedTwitterProfile?.profile_image_url || '';
	const showNewsSection = news.length > 0 || teamTwitterInfo.length > 0;
	const upcomingMatches = [
		{
			id: 'static-1',
			away: { shortName: 'PBKS', logoUrl: '' },
			home: { shortName: 'RCB', logoUrl: '' }
		},
		{
			id: 'static-2',
			away: { shortName: 'MI', logoUrl: '' },
			home: { shortName: 'PBKS', logoUrl: '' }
		},
		{
			id: 'static-3',
			away: { shortName: 'MI', logoUrl: '' },
			home: { shortName: 'GT', logoUrl: '' }
		}
	];

	const renderTeamBadge = (team) => {
		const shortName = team?.shortName || '';
		const logoUrl = team?.logoUrl || '';
		return (
			<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
				<div
					style={{
						width: '56px',
						height: '56px',
						borderRadius: '50%',
						backgroundColor: '#fff',
						border: '1px solid rgba(0,0,0,0.12)',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						overflow: 'hidden'
					}}
				>
					{logoUrl ? (
						<img src={logoUrl} alt={shortName} style={{ width: '44px', height: '44px', objectFit: 'contain' }} />
					) : (
						<span style={{ fontWeight: 700, color: '#c00' }}>{shortName.slice(0, 3).toUpperCase()}</span>
					)}
				</div>
				<div style={{ fontSize: '12px', fontWeight: 700, color: '#111' }}>{shortName}</div>
			</div>
		);
	};

	return (
		<section className='gameMainSection'>
			<div className='gameMainDiv one'>

				<section className="userHeaderSection userHeaderMatchSection" style={{position: 'relative', top: 0, backgroundColor: 'rgb(247, 247, 247)'}}>
					<div className="userHeaderTextRow row">
						<div className="container">
							<div className="userHeaderNameCol userHeaderNameMatchCol col-lg-12">
								<p className="userHeaderDescription"></p>
								<div className="userHeaderDateDiv">
									<div className="userHeaderNavDiv">
										<a className="userHeaderNavLink hover-delay" href="/cricket/upcominggames?league=IPL">
											<p className="userHeaderNavItem">IPL </p>
										</a>
										<span className="userHeaderNavArrow">&gt;</span>
										<a className="userHeaderNavLink hover-delay" href="#">
											<p className="userHeaderNavItem">Team</p>
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>				
				<div className="gameBoxShadow">
					<div className="gameSpreadHeaderRow row">
						<div className="gameSpreadHeaderCol teamHighlightYellow col-lg-12">
							<div className="gameSpreadHeaderDiv">
								<p className="gameSpreadHeaderSpread">
									<span style={{paddingRight: '20px', fontWeight: 'bold'}}>GOOD</span>{teamInfo.team_gaming_score || '5.35'}
								</p>
								<p className="gameSpreadHeaderDescription">Team Health Score</p>
							</div>
						</div>
					</div>
					<div className="gameTeamHeaderRow row">
						<div className="gameTeamHeaderCol teamShadowHighlight col-xs-12 col-lg-12">
							<div className="gameTeamHeaderDiv displayLogoTable">
								<p className="gameTeamHeaderSpread bold teamHighlightYellow">{teamInfo.team_gaming_score || '5.35'}</p>
								<div className="gameTeamHeaderLogoDiv">
									{/* Team Header */}
									{teamInfo.logo_url && (
										<img src={teamInfo.logo_url} alt={teamInfo.team_name}className='gameTeamLogo' />
										)}
										<p className="gameTeamHeaderName gameTeamHeaderNameAway">{teamInfo.team_name}</p>

										{/* Team Stats */}
								</div>
							</div>
						</div>
					</div>
					<div className="gameLegendRow row">
						<div className="gameLegendCol col-lg-2">
							<p className="gameLegenLabelText">HEALTH SCORE</p>
						</div>
						<div className="gameLegendCol col-lg-2">
							<div className="gameLegendStatusDiv">
								<div className="gameLegendBox cardSpreadDarkGreen"></div>
								<p className="gameLegendStatus">Optimal Health <br />8 - 10</p>
							</div>
							{state.showLegend && <p className="gameLegendInfo">Completely healthy, or close to healthy, with key players contributing at expected levels of production.</p>}
						</div>
						<div className="gameLegendCol col-lg-2">
							<div className="gameLegendStatusDiv">
								<div className="gameLegendBox cardSpreadGreen"></div>
								<p className="gameLegendStatus">Good Health<br />6 - 8</p>
							</div>
							{state.showLegend && <p className="gameLegendInfo">Relatively healthy, resulting in contributions slightly lower than projected levels.</p>}
						</div>
						<div className="gameLegendCol col-lg-2">
							<div className="gameLegendStatusDiv">
								<div className="gameLegendBox cardSpreadYellow"></div>
								<p className="gameLegendStatus">Moderate Health<br />4 - 6</p>
							</div>
							{state.showLegend && <p className="gameLegendInfo">Some injury(ies) leading to underperformance when compared to expectations or projections.</p>}
						</div>
						<div className="gameLegendCol col-lg-2">
							<div className="gameLegendStatusDiv">
								<div className="gameLegendBox cardSpreadRed"></div>
								<p className="gameLegendStatus">Poor Health<br />1 - 4</p>
							</div>
							{state.showLegend && <p className="gameLegendInfo">Significant injury(ies) resulting in substantial underperformance compared to expected levels of production.</p>}
						</div>
						<div className="gameLegendCol col-lg-2">
							<a href="#/" className="gameLegendArrowLink" title="Legend Arrow">
								<img
									src={upArrow}
									className={`gameLegendArrow${!state.showLegend ? ' gameLegendArrowRotate' : ''}`}
									alt="Arrow Symbol"
									onClick={(e) => {
										e.preventDefault();
										toggleLegend();
									}}
								/>
							</a>
						</div>
					</div>

				<div className="gameMatchupRow row">
					<div className="gameMatchupHeaderCol gameMatchupHeaderCol1 col-lg-6">
						<div className="matchupHeaderDiv">
							<div className="row">
								<div className="col-lg-8 matchupHeaderCol">
									<hr className="hrStyleMobile" />
									<p className="matchupMobileHeader">
										{teamInfo.team_name}
									</p>
									<hr className="hrStyleMobile" />
								</div>
								<div className="col-lg-3 matchupHeaderCol">
									<p className="matchupHeader">Health Score</p>
								</div>
								<div className="col-lg-1" />
							</div>
						</div>
						<React.Fragment>
							<div style={{paddingBottom: '30px'}}>
								{(() => {
									// Group players by position category
									const groupedPlayers = {
										bat: [],
										bowl: [],
										all: [],
										wk: []
									};

									(state.players || []).forEach(player => {
										const category = player.position_category;
										if (groupedPlayers[category]) {
											groupedPlayers[category].push(player);
										}
									});

									// Calculate average health score for each category
									const getCategoryHealth = (players) => {
										if (players.length === 0) return 0;
										const total = players.reduce((sum, p) => sum + (p.health_score || 0), 0);
										return total / players.length;
									};

									// Get status and CSS class based on health score
									const getHealthStatus = (score) => {
										if (score >= 8) return { status: 'OPTIMAL', class: 'cardSpreadDarkGreen' };
										if (score >= 6) return { status: 'GOOD', class: 'cardSpreadGreen' };
										if (score >= 4) return { status: 'MODERATE', class: 'cardSpreadYellow' };
										return { status: 'POOR', class: 'cardSpreadRed' };
									};

									const categories = [
										{ key: 'bat', emoji: '🏏', name: 'BATTERS' },
										{ key: 'bowl', emoji: '🔴', name: 'BOWLERS' },
										{ key: 'all', emoji: '', name: 'ALL-ROUNDERS' },
										{ key: 'wk', emoji: '🧤', name: 'WICKET-KEEPER' }
									];

									return categories.map((category, index) => {
										const players = groupedPlayers[category.key];
										const healthScore = getCategoryHealth(players);
										const healthInfo = getHealthStatus(healthScore);
										const isExpanded = state.expandedCategories[category.key];

										return (
											<div key={category.key} className="matchMainDiv">
												<div id="matchGroup" className="dropdown">
													<button 
														className="dropdown-toggle dropdownMenuButton"
														type="button"
														id={`dropdownMenuButton${index + 101}`}
														data-toggle="dropdown"
														data-parent="#matchGroup"
														aria-haspopup="true"
														onClick={() => toggleCategory(category.key)}
													>
														<div className="matchupButtonRow row">
															<div className="matchupTitleDropdownCol col-lg-8">
																<div className="matchupTitleDropdown">
																	<p className="matchupTitle">
																		{category.emoji} {category.name}
																	</p>
																	<img 
																		src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAALCAYAAAByF90EAAAABHNCSVQICAgIfAhkiAAAALJJREFUKJGV0C9uQkEQB+B9BIVC9wDYqvqqKlwvgOUE5NleANEE2VBCguEO9UgcB8BhKhpCCPlqXnLh5f3rz+3s7JeZTSmlhCmWyFLHYI48FnJ/+eyCYRbevCNLeHOfTROGSal/i14csxXDK26h7wv9qp1rMbzgGu53GNSNvajC8IRzqB8wbPvIMrbHdzgf8dCIBOxDdU4YdUIKKKvAfvDYGSlh6wK54PnfSMB6WGHc1vsLAqtfu/4d9ZQAAAAASUVORK5CYII=" 
																		alt="Dropdown Arrow" 
																		id="matchupTitleDropdownArrow" 
																		className={`matchupTitleDropdownArrow${!isExpanded ? ' matchupTitleDropdownArrowRotate' : ''}`}
																	/>
																</div>
															</div>
															<div className={`matchupStatusCol ${healthInfo.class} col-lg-3`}>
																<div className="matchupInfoDiv">
																	<p className="matchupStatus">{healthInfo.status}</p>
																</div>
															</div>
														</div>
													</button>
													
													<div 
														className={`dropdown-menu${isExpanded ? ' show' : ''} matchMenuDiv`}
														aria-labelledby="dropdownMenuButton" 
														data-parent="#matchGroup" 
														id="menuID"
													>
														{players.map(player => {
																		// Determine background color based on health score
																		const playerHealth = player.health_score || 0;
																		let backgroundColor = '#ffebeb'; // Light red for poor health
																		if (playerHealth >= 8) {
																			backgroundColor = '#e6f9ed'; // Light green for optimal
																		} else if (playerHealth >= 6) {
																			backgroundColor = '#ebf5e6'; // Very light green for good
																		} else if (playerHealth >= 4) {
																			backgroundColor = '#fff8dc'; // Light yellow for moderate
																		}

																		return (
																			<div key={player.player_id} className="dropdown-item matchPlayerItem">
																				<a className="routerLinkMatchup hover-delay" title={player.player_name} href={`/cricket/ipl/player/${player.player_id}`}>
																					<div className="matchPlayerItemRow row">
																						<div className="matchPlayerItemCol col-lg-12" style={{
																							backgroundColor: backgroundColor,
																							border: '1px solid #e0e0e0',
																							borderRadius: '10px',
																							boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
																							marginBottom: '12px'
																						}}>
																							<div className="matchPlayerDiv displayTable">
																								{teamInfo.logo_url && (
																								<img src={teamInfo.logo_url} alt={teamInfo.team_name}className='matchPlayerImg displayTableCell' />
																								)}

																								<div className="matchPlayerInfoDiv displayTableCell">
																									<p className="matchPlayerInfoName">
																										<span className="grey">NAME:</span>
																										<span className="matchPlayerInfo">{player.player_name}</span>
																									</p>
																									<p className="matchPlayerInfoInjury">
																										<span className="grey">POSITION:</span>
																										<span className="matchPlayerInfo">{player.position || ''}</span>
																									</p>
																									<p className="matchPlayerInfoInjury">
																										<span className="grey">Height:</span>
																										<span className="matchPlayerInfo">{convertInchesToFeet(player.height)}</span>
																									</p>
																									<p className="matchPlayerInfoInjury">
																										<span className="grey">Weight:</span>
																										<span className="matchPlayerInfo">{player.weight ? `${player.weight} kg` : 'N/A'}</span>
																									</p>
																									<p className="matchPlayerInfoHealth">
																										<span className="grey">AGE:</span>
																										<span className="matchPlayerInfo">{calculateAge(player.date_of_birth)}</span>
																									</p>																									
																									<p className="matchPlayerInfoInjury">
																										<span className="grey">HEALTH SCORE:</span>
																										<span className="matchPlayerInfo" style={{
																											color: playerHealth >= 8 ? '#28a745' : 
																												   playerHealth >= 6 ? '#04b876' : 
																												   playerHealth >= 4 ? '#ffc107' : '#dc3545'
																										}}>{playerHealth}</span>
																									</p>
																								</div>
																							</div>
																						</div>
																					</div>
																				</a>
																			</div>
																		);
																	})}
																</div>
														</div>
												</div>
										);
									});
								})()}
							</div>
						</React.Fragment>
						<div className="topFourPlayerDiv">
							<h1 className="dashboardHowItWorksHeader text-center">Key Players</h1>
						</div>
						<div className="matchupHeaderDiv">
							<div className="row">
								{(() => {
									// Use dynamic player data from API and sort by gaming score to get top 5
									const topPlayers = (state.players || [])
										.sort((a, b) => (b.health_score || 0) - (a.health_score || 0))
										.slice(0, 5);

									return topPlayers.map((player, index) => (
										<div className="col-lg-6" key={player.player_id}>
											<a 
												className="routerLinkMatchup hover-delay" 
												title={player.player_name} 
												href={`/cricket/ipl/player/${player.player_id}`}
											>
												<div className="matchPlayerDiv">
													<div className="matchPlayerInfoDiv matchPlayerInfoTopDiv">
														<p className="matchPlayerInfoNameTop">{player.nickname || player.player_name}</p>
														<p className="matchPlayerInfoInjury">
															<span className="grey">POSITION:</span>
															<span className="matchPlayerInfo">{player.position}</span>
														</p>
														<p className="matchPlayerInfoInjury">
															<span className="grey">HEALTH SCORE:</span>
															<span className="matchPlayerInfo">{player.health_score || '10'}</span>
														</p>
													</div>
												</div>
											</a>
										</div>
									));
								})()}
							</div>
						</div>
						<div className="matchMainDiv">
							<div id="matchGroup" className="dropdown">
								<div className="dropdown-menu show matchMenuDiv" aria-labelledby="dropdownMenuButton" data-parent="#matchGroup" id="menuID">
									<div>
										<p className="fullRosterHpf">Health Score is the average impact that current and/or previous injuries have on the performance of a player. The higher the number is, the less impactful current/previous injuries will be on player performance.</p>
										{(() => {
											// Show only top 5 key players (same as summary cards)
											const topPlayers = (state.players || [])
												.sort((a, b) => (b.health_score || 0) - (a.health_score || 0))
												.slice(0, 5);

											return topPlayers.map((player) => {
												// Determine background color based on health score
												const healthScore = player.health_score || 0;
												let backgroundColor = '#d4edda'; // Light green background like in attachment
												if (healthScore < 4) {
													backgroundColor = '#ffebeb'; // Light red for poor health
												} else if (healthScore < 6) {
													backgroundColor = '#fff8dc'; // Light yellow for moderate
												} else if (healthScore < 8) {
													backgroundColor = '#e6f9ed'; // Light green for good
												} else {
													backgroundColor = '#d4edda'; // Optimal green like attachment
												}

												return (
													<div key={player.player_id} className="dropdown-item matchPlayerItem">
														<a className="routerLinkMatchup hover-delay" title={player.player_name} href={`/cricket/ipl/player/${player.player_id}`}>
															<div className="matchPlayerItemRow row">
																<div className="matchPlayerItemCol col-lg-12" style={{
																	backgroundColor: backgroundColor,
																	border: '1px solid #e0e0e0',
																	borderRadius: '10px',
																	boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
																	marginBottom: '12px'
																}}>
																	<div className="matchPlayerDiv displayTable">
																		<img src={teamInfo.logo_url} alt={teamInfo.team_name} className="matchPlayerImg displayTableCell" />
																		<div className="matchPlayerInfoDiv displayTableCell">
																			<p className="matchPlayerInfoName">
																				<span className="grey">NAME:</span>
																				<span className="matchPlayerInfo">{player.player_name}</span>
																			</p>
																			<p className="matchPlayerInfoInjury">
																				<span className="grey">POSITION:</span>
																				<span className="matchPlayerInfo">{player.position || ''}</span>
																			</p>
																			<p className="matchPlayerInfoInjury">
																				<span className="grey">Height:</span>
																				<span className="matchPlayerInfo">{convertInchesToFeet(player.height)}</span>
																			</p>
																			<p className="matchPlayerInfoInjury">
																				<span className="grey">Weight:</span>
																				<span className="matchPlayerInfo">{player.weight ? `${player.weight} kg` : 'N/A'}</span>
																			</p>
																			<p className="matchPlayerInfoHealth">
																				<span className="grey">AGE:</span>
																				<span className="matchPlayerInfo">{calculateAge(player.date_of_birth)}</span>
																			</p>
																			<p className="matchPlayerInfoInjury">
																				<span className="grey">HEALTH SCORE:</span>
																				<span className="matchPlayerInfo" style={{
																					color: healthScore >= 8 ? '#28a745' : 
																						   healthScore >= 6 ? '#04b876' : 
																						   healthScore >= 4 ? '#ffc107' : '#dc3545'
																				}}>{healthScore}</span>
																			</p>
																		</div>
																	</div>
																</div>
															</div>
														</a>
													</div>
												);
											});
										})()}
									</div>
								</div>
							</div>
							<br />
						</div>
					</div>
					<div className="gameMatchupHeaderCol gameMatchupHeaderCol1 col-lg-6">
						<div className="matchupHeaderDiv">
							<div className="row">
								<div className="matchupHeaderCol col-lg-12">
									<h1 className="dashboardHowItWorksHeader text-center">Season Schedules</h1>
								</div>
							</div>
						</div>
						<div style={{paddingBottom: '30px'}}>
							{state.schedulesLoading ? (
								<div style={{ textAlign: 'center', padding: '40px' }}>
									<p>Loading schedules...</p>
								</div>
							) : state.schedules.length === 0 ? (
								<div style={{ textAlign: 'center', padding: '40px' }}>
									<p>No upcoming schedules found</p>
								</div>
							) : (
								<div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '10px' }}>
									{state.schedules.map((schedule, index) => {
										const activeTeamId = `${teamInfo?.team_id || teamID}`;
										const isTeamA = `${schedule.team_a_id || ''}` === activeTeamId;
										const opponent = isTeamA ? 
											{ id: schedule.team_b_id, name: schedule.team_b_name, shortName: schedule.team_b_short_name, logo: schedule.team_b_logo_url } :
											{ id: schedule.team_a_id, name: schedule.team_a_name, shortName: schedule.team_a_short_name, logo: schedule.team_a_logo_url };
										const currentTeam = isTeamA ?
											{ id: schedule.team_a_id, name: schedule.team_a_name, shortName: schedule.team_a_short_name, logo: schedule.team_a_logo_url } :
											{ id: schedule.team_b_id, name: schedule.team_b_name, shortName: schedule.team_b_short_name, logo: schedule.team_b_logo_url };
										const scheduleHref = schedule.match_id ? `/cricket/matchup/${schedule.match_id}` : null;

										return (
											<a 
												key={schedule.match_id || index} 
												href={scheduleHref || undefined}
												style={{ textDecoration: 'none', color: 'inherit' }}
											>
												<div style={{
													border: '1px solid #ddd', 
													padding: '12px', 
													borderRadius: '8px',
													backgroundColor: '#fff',
													cursor: scheduleHref ? 'pointer' : 'default',
													transition: 'all 0.2s ease',
													boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
												}}
												onMouseEnter={(e) => {
													if (!scheduleHref) return;
													e.currentTarget.style.transform = 'translateY(-2px)';
													e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
												}}
												onMouseLeave={(e) => {
													if (!scheduleHref) return;
													e.currentTarget.style.transform = 'translateY(0)';
													e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
												}}>
													<div style={{ textAlign: 'left', color: '#888', fontSize: '12px' }}>
														{schedule.format_str || 'IPL'} · {schedule.match_number || `Match ${index + 1}`} 
														<span style={{float: 'right'}}>{formatDate(schedule.date_start_ist)}</span>
													</div>
													<div style={{marginTop: '8px', display: 'flex', alignItems: 'center', gap: '8px'}}>
														{renderTeamLogo(currentTeam.shortName || currentTeam.name, currentTeam.logo)}
														{currentTeam.shortName || currentTeam.name}
													</div>
													<div style={{marginTop: '6px', display: 'flex', alignItems: 'center', gap: '8px'}}>
														{renderTeamLogo(opponent.shortName || opponent.name, opponent.logo)}
														{opponent.shortName || opponent.name}
													</div>
													<div style={{ textAlign: 'left', marginTop: '6px', color: '#555'}}>
														{schedule.status_str || 'Scheduled'} {schedule.date_start_ist && `at ${formatTime(schedule.date_start_ist)}`}
													</div>
													{schedule.title && schedule.title !== schedule.short_title && (
														<div style={{ textAlign: 'left', marginTop: '4px', color: '#777', fontSize: '11px' }}>
															{schedule.title}
														</div>
													)}
												</div>
											</a>
										);
									})}
								</div>
							)}
						</div>
					</div>
				</div>

				<div className='gameBoxShadow'>
					<div style={{ padding: '0 30px' }}>
							{showNewsSection && (
							<div className="news-container">
								{news.length > 0 && (
								<div className='news-column aggregated player-stats'>
									<div className="header-with-svg" style={{
										position: 'sticky',
										top: '0',
										backgroundColor: '#fff',
										zIndex: 10,
										padding: '10px 0',
										borderBottom: '1px solid #e0e0e0',
										marginBottom: '10px'
									}}>
										<svg fill="#000000" width="40px" height="40px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><title>ionicons-v5_logos</title><path d="M108.56,342.78a60.34,60.34,0,1,0,60.56,60.44A60.63,60.63,0,0,0,108.56,342.78Z"/><path d="M48,186.67v86.55c52,0,101.94,15.39,138.67,52.11s52,86.56,52,138.67h86.66C325.33,312.44,199.67,186.67,48,186.67Z"/><path d="M48,48v86.56c185.25,0,329.22,144.08,329.22,329.44H464C464,234.66,277.67,48,48,48Z"/></svg>
										<p className='large-heading playerTotalInjury'><strong>Aggregated IBL News</strong></p>
									</div>
									<ul className='news-column aggregated list-unstyled'>
										{news.map((item, index) => (
									<div key={item.newsId || index} style={{
										background: 'white',
										border: '1px solid #e0e0e0',
										borderRadius: '8px',
										padding: '20px',
										marginBottom: '15px',
										boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
									}}>
										{item.Updated && (
											<p style={{ 
												fontSize: '12px', 
												color: '#777', 
												marginBottom: '8px' 
											}}>
												{new Date(item.Updated).toLocaleDateString()}
											</p>
										)}
										<h5 style={{ 
											margin: '0 0 10px 0', 
											color: '#333', 
											fontWeight: 'bold' 
										}}>
											{item.Title || item.headline || 'Team News Update'}
										</h5>
										{item.Content && (
											<p style={{
												margin: 0,
												color: '#666',
												lineHeight: '1.5'
											}}>
												{item.Content}
											</p>
										)}
									</div>
								))}
									</ul>
								</div>
								)}
								{teamTwitterInfo.length > 0 && (
									<PlayerTwitterFeed
										tweets={teamTwitterInfo}
										twitter_handle={twitterHandle}
										twitter_profile_image={twitterProfileImage}
									/>
								)}
								{false && (
								<div className="news-column twitter-feed">
									<div className="news-header" style={{
										position: 'sticky',
										top: '0',
										backgroundColor: '#fff',
										zIndex: 10,
										padding: '10px 0',
										borderBottom: '1px solid #e0e0e0',
										marginBottom: '10px'
									}}>
										<img
										src="https://img.icons8.com/ios-filled/24/twitterx--v2.png" alt="X logo" />
										<h2>@RoquanSmith1</h2>
									</div>
									<div className="news-post">
										<div className="post-profile">
										<img
											src="https://nitter.net/pic/profile_images%2F996494135560318976%2FpMcitFXF_bigger.jpg"
											alt="profile"
											width="50px"
										/>
										</div>
										<div className="news-body">
											<div className="post-header">
												<p>
												<strong className="username">RoquanSmith1</strong>
												<span className="postdate"> · 7/13/2019</span>
												</p>
											</div>
											<div className="post-body">
												<p>
												@The_Duffer_Bros I am now officially convinced that Jim will be
												rescued by the US GOVT in the upsidedown and asked to reenlist and
												battle another alien because of his monster battling track record.
												#StrangerThings #Predator
												</p>
											</div>
										</div>
									</div>
									<div className="news-post">
										<div className="post-profile">
										<img
											src="https://nitter.net/pic/profile_images%2F996494135560318976%2FpMcitFXF_bigger.jpg"
											alt="profile"
											width="50px"
										/>
										</div>
										<div className="news-body">
											<div className="post-header">
												<p>
												<strong className="username">RoquanSmith1</strong>
												<span className="postdate"> · 7/13/2019</span>
												</p>
											</div>
											<div className="post-body">
												<p>
												@The_Duffer_Bros I am now officially convinced that Jim will be
												rescued by the US GOVT in the upsidedown and asked to reenlist and
												battle another alien because of his monster battling track record.
												#StrangerThings #Predator
												</p>
											</div>
										</div>
									</div>
									<div className="news-post">
										<div className="post-profile">
										<img
											src="https://nitter.net/pic/profile_images%2F996494135560318976%2FpMcitFXF_bigger.jpg"
											alt="profile"
											width="50px"
										/>
										</div>
										<div className="news-body">
											<div className="post-header">
												<p>
												<strong className="username">RoquanSmith1</strong>
												<span className="postdate"> · 7/13/2019</span>
												</p>
											</div>
											<div className="post-body">
												<p>
												@The_Duffer_Bros I am now officially convinced that Jim will be
												rescued by the US GOVT in the upsidedown and asked to reenlist and
												battle another alien because of his monster battling track record.
												#StrangerThings #Predator
												</p>
											</div>
										</div>
									</div>
									<div className="news-post">
										<div className="post-profile">
										<img
											src="https://nitter.net/pic/profile_images%2F996494135560318976%2FpMcitFXF_bigger.jpg"
											alt="profile"
											width="50px"
										/>
										</div>
										<div className="news-body">
											<div className="post-header">
												<p>
												<strong className="username">RoquanSmith1</strong>
												<span className="postdate"> · 7/13/2019</span>
												</p>
											</div>
											<div className="post-body">
												<p>
												@The_Duffer_Bros I am now officially convinced that Jim will be
												rescued by the US GOVT in the upsidedown and asked to reenlist and
												battle another alien because of his monster battling track record.
												#StrangerThings #Predator
												</p>
											</div>
										</div>
									</div>
								</div>
								)}

							</div>
						)}



					</div>
				</div>
			</div>
		</div>
	</section>
	);

}

const mapStateToProps = (state) => ({
	user: state.user
});

export default connect(mapStateToProps)(CricketTeamDetails);
